import { Text } from '@mantine/core';

/**
 * YAZAMAMA SEBEBİ — SALT OKUNUR BÖLÜMÜN TEK SATIRI (gezinti artçısı 2 / B3;
 * CLAUDE.md §2.40).
 *
 * > **Yazamayan şapkada bölüm boş görünür ve kullanıcı bunu EKSİKLİK sanar.**
 * > Ürün sahibi KKD zimmetinde tam olarak bunu yaşadı: yetki kapısı doğru
 * > çalışıyordu, ekleme satırı doğru gizleniyordu — ama neden olmadığı
 * > söylenmiyordu.
 *
 * §2.40 sıralaması: kontrol çalışamayacaksa **görünmez ya da salt okunur**
 * olur; bu satır salt okunurluğun **sebebidir.**
 *
 * ⚠️ **M1 İSTİSNASI — KARAR ANINDA BİLGİ, KAVRAM AÇIKLAMASI DEĞİL.** Metin
 * *"bunu kim yapar"* ya da *"neden kilitli"* der; özelliğin ne olduğunu
 * anlatmaz. Tek satır, tek cümle.
 *
 * ⚠️ **METNİ ÇAĞIRAN KAPININ KENDİ KAYNAĞINDAN KURAR:** şapka listesi kapının
 * sabitinden (`sapkaListesiMetni`), sunucu kapısının sebebi yanıttan gelir.
 * Elle yazılmış bir *"yalnız uzman ekler"* cümlesi, liste değiştiği gün
 * **yalan söyler** — sebepsiz boşluktan daha kötü bir hâl.
 *
 * ⚠️ Yalnız YAZAMAYAN kullanıcıda çizilir; yazabilen kullanıcıya bir kısıt
 * cümlesi göstermek gürültüdür.
 */
export function YazamamaSebebi({
  children,
  testId,
}: {
  children: React.ReactNode;
  testId: string;
}): React.JSX.Element {
  return (
    <Text size="xs" c="dimmed" mt="xs" data-testid={testId}>
      {children}
    </Text>
  );
}
